
export const blocks = [
  {
    name: `nyfw`,
    title: `Most Loved: NYFW`,
    blockTitle: `NYC: Oscar de la Renta`,
    image: require('@/assets/chapters/ch2/1_nyfw.jpg'),
    fullResImage: require('@/assets/chapters/ch2/1_nyfw_fr.jpg')
  },
  {
    name: `mfw`,
    title: `Most Loved: MFW`,
    blockTitle: `Milan: Prada`,
    image: require('@/assets/chapters/ch2/2_mfw.jpg'),
    fullResImage: require('@/assets/chapters/ch2/2_mfw_fr.jpg')
  },
  {
    name: `pfw`,
    title: `Most Loved: PFW`,
    blockTitle: `Paris: Jacquemus`,
    image: require('@/assets/chapters/ch2/3_pfw.jpg'),
    fullResImage: require('@/assets/chapters/ch2/3_pfw_fr.jpg')
  },
  {
    name: `lfw`,
    title: `Most Loved: LFW`,
    blockTitle: `London: Victoria Beckham`,
    blockContent: `lfw`,
    image: require('@/assets/chapters/ch2/4_lfw.jpg'),
    fullResImage: require('@/assets/chapters/ch2/4_lfw_fr.jpg')
  }
]

export default blocks
